import React from "react";
import { Row, Col } from "react-flexbox-grid";
import ModelCard from "../../components/ui-components/modelCard/modelCard.jsx";
import "./hero.scss";
import HeroImage from '../../assets/hero/hero-image.png';
import DemoAsset from '../../assets/hero/500g.glb';
import Button from '../ui-components/button/button';

const hero = () => (
  <div className="hero" id="hero">
    <div className="wrapper">
      <div className="hero-info">
        <h1 className="weight800 font60">
        Seu produto em uma experiência visual única para o publico.
        </h1>
        <p className="font16">
        Criamos experiências visuais que valorizam seu produto, destacando seu uso com técnicas que instigam a decisão de compra. A iluminação e a composição visual são trabalhadas estrategicamente para guiar o olhar do consumidor, criar impacto e transmitir confiança. Nosso objetivo é transformar visualizações em resultados concretos.
        </p>
        <Button label="SEND MESSAGE" target={"contact"} />
        </div>
        <div className="model-demo">
      <ModelCard
          modelSrc={DemoAsset}
        />
      </div>
      
    </div>
  </div>
);

export default hero;
